import { AfterViewInit, Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { Chart, registerables } from 'chart.js';
import { register } from 'swiper/element/bundle';
import { addIcons } from 'ionicons';
import {
  addCircle,
  addOutline,
  alertCircle,
  alertCircleOutline,
  arrowBackOutline,
  arrowRedoOutline,
  arrowUndoOutline,
  atOutline,
  barChartOutline,
  bookmarkOutline,
  briefcaseOutline,
  businessOutline,
  calendarOutline,
  callOutline,
  cameraOutline,
  caretDownOutline,
  caretForwardOutline,
  documentLockOutline,
  caretUpOutline,
  cellularOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronBackOutline,
  chevronDownOutline,
  chevronUpOutline,
  closeCircleOutline,
  closeOutline,
  cloudyOutline,
  compassOutline,
  constructOutline,
  documentAttachOutline,
  documentOutline,
  documentsOutline,
  eyeOffOutline,
  eyeOutline,
  fileTrayFullOutline,
  filterOutline,
  flameOutline,
  flashOutline,
  help,
  hourglassOutline,
  information,
  informationCircleOutline,
  informationOutline,
  keyOutline,
  lockClosedOutline,
  logOutOutline,
  man,
  newspaperOutline,
  paperPlaneOutline,
  peopleOutline,
  personAddOutline,
  personOutline,
  phonePortraitOutline,
  pinOutline,
  refreshOutline,
  reloadOutline,
  removeCircle,
  reorderTwoOutline,
  saveOutline,
  searchOutline,
  sendOutline,
  skullOutline,
  statsChartOutline,
  trashOutline,
  wifiOutline,
} from 'ionicons/icons';

Chart.register(...registerables);

addIcons({
  addCircle,
  addOutline,
  alertCircle,
  alertCircleOutline,
  arrowBackOutline,
  arrowRedoOutline,
  arrowUndoOutline,
  atOutline,
  barChartOutline,
  documentLockOutline,
  bookmarkOutline,
  briefcaseOutline,
  businessOutline,
  calendarOutline,
  callOutline,
  cameraOutline,
  caretDownOutline,
  caretForwardOutline,
  caretUpOutline,
  cellularOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  checkmarkOutline,
  chevronBackOutline,
  chevronDownOutline,
  chevronUpOutline,
  closeCircleOutline,
  closeOutline,
  cloudyOutline,
  compassOutline,
  constructOutline,
  documentAttachOutline,
  documentOutline,
  documentsOutline,
  eyeOffOutline,
  eyeOutline,
  fileTrayFullOutline,
  filterOutline,
  flameOutline,
  flashOutline,
  help,
  hourglassOutline,
  information,
  informationCircleOutline,
  informationOutline,
  keyOutline,
  lockClosedOutline,
  logOutOutline,
  man,
  newspaperOutline,
  paperPlaneOutline,
  peopleOutline,
  personAddOutline,
  personOutline,
  phonePortraitOutline,
  pinOutline,
  refreshOutline,
  reloadOutline,
  removeCircle,
  reorderTwoOutline,
  saveOutline,
  searchOutline,
  sendOutline,
  skullOutline,
  statsChartOutline,
  trashOutline,
  wifiOutline,
});

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements AfterViewInit {
  constructor() {}

  ngAfterViewInit(): void {
    register();
  }
}
